import http from "../http-common";

class AsignmentService {
  getAll(params = {}) {
    return http.get("/asignments", { params });
  }

  get(id) {
    return http.get(`/asignments/${id}`);
  }

  create(data) {
    return http.post("/asignments", data);
  }

  update(id, data) {
    return http.put(`/asignments/${id}`, data);
  }

  delete(id) {
    return http.delete(`/asignments/${id}`);
  }
}

export default new AsignmentService();
